import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.75 16.25H5.987c.25-.491.5-.997.75-1.51 1.406.154 3.054-.823 4.937-2.92.469 1.262 1.354 2.9 2.867 2.93.849.017 1.697-.488 2.57-1.535.637.762 1.948 1.535 4.639 1.535a.75.75 0 1 0 0-1.5c-2.853 0-3.697-.98-3.75-1.51a.72.72 0 0 0-.512-.727.76.76 0 0 0-.867.327c-1.132 1.738-1.817 1.916-2.055 1.91-.774-.015-1.562-1.83-1.832-3.133a.75.75 0 0 0-1.32-.316c-1.895 2.376-3.164 3.175-3.954 3.382.796-1.769 1.39-3.322 1.77-4.63.64-2.197.687-3.734.142-4.697-.281-.504-.875-1.106-2.068-1.106-1.506 0-2.693 1.423-3.26 3.905-.336 1.472-.391 3.113-.151 4.5.24 1.386.737 2.395 1.461 2.994-.35.724-.706 1.43-1.053 2.101H2.25a.75.75 0 1 0 0 1.5h1.257a90 90 0 0 1-1.9 3.364.75.75 0 1 0 1.286.772c.014-.024 1.057-1.761 2.316-4.136H21.75a.75.75 0 1 0 0-1.5M5.507 6.988C5.88 5.351 6.603 4.25 7.304 4.25c.5 0 .666.174.762.344.281.5.611 2.268-2.03 8.1-.775-1.058-1.038-3.475-.53-5.706"
    }, null, -1)
  ])))
}
export default { render: render }